window.popup=function(){
    $(".mask").height($(document).height());
    $(".mask,.popup").show();
};
window.popupClose=function(){
    $(".mask,.popup").hide();
};